/**
 * How a keybinding's combo reads on this platform. `mod` is the registry's
 * portable modifier token; the glyph is display only, and nothing reads it
 * back to work out which key a binding uses.
 */
const PORTABLE_MODIFIER = "mod";

export function comboForDisplay(combo: string): string {
  return combo.replace(PORTABLE_MODIFIER, "\u2318");
}
